._line_16rp3_1 {
  position: absolute;
  z-index: 2;
  background: rgba(154, 154, 154, 0.1);
  animation: _appear_16rp3_1 1s ease-in-out forwards; }
  ._lineHorizontal_16rp3_6 {
    width: 100%;
    height: 1px; }
    ._lineHorizontal_16rp3_6 ._glow_16rp3_9 {
      height: 100%; }
      ._lineHorizontal_16rp3_6 ._glowIdle_16rp3_11 {
        width: var(--idle-size); }
      ._lineHorizontal_16rp3_6 ._glowImpulseFromRight_16rp3_13 {
        transform-origin: 20% 0;
        background: var(--line-glow-background-direction-to-left);
        width: 65%;
        transform: translateX(var(--container-width)) scaleX(0.8); }
      ._lineHorizontal_16rp3_6 ._glowImpulseFromCenterOne_16rp3_18, ._lineHorizontal_16rp3_6 ._glowImpulseFromCenterTwo_16rp3_18 {
        width: 50%;
        transform: scaleX(0); }
      ._lineHorizontal_16rp3_6 ._glowImpulseFromCenterOne_16rp3_18 {
        transform-origin: calc(100% - 20%) 0;
        background: var(--line-glow-background-direction-to-right);
        left: 10%; }
      ._lineHorizontal_16rp3_6 ._glowImpulseFromCenterTwo_16rp3_18 {
        transform-origin: 20% 0;
        background: var(--line-glow-background-direction-to-left);
        left: 40%; }
  ._lineVertical_16rp3_29 {
    width: 1px;
    height: 100%; }
    ._lineVertical_16rp3_29 ._glow_16rp3_9 {
      width: 100%; }
      ._lineVertical_16rp3_29 ._glowIdle_16rp3_11 {
        height: var(--idle-size); }
      ._lineVertical_16rp3_29 ._glowImpulseFromCenterOne_16rp3_18, ._lineVertical_16rp3_29 ._glowImpulseFromCenterTwo_16rp3_18 {
        height: 50%;
        transform: scaleY(0); }
      ._lineVertical_16rp3_29 ._glowImpulseFromCenterOne_16rp3_18 {
        transform-origin: 0 20%;
        background: var(--line-glow-background-direction-to-top);
        top: 40%; }
      ._lineVertical_16rp3_29 ._glowImpulseFromCenterTwo_16rp3_18 {
        transform-origin: 0 calc(100% - 20%);
        background: var(--line-glow-background-direction-to-bottom);
        top: 10%; }

._glow_16rp3_9 {
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform, opacity;
  z-index: 2;
  opacity: 0.8; }
  ._glowIdleWrapper_16rp3_55 {
    transition: opacity 1s; }

._animationIdle_16rp3_58._line_16rp3_1 {
  position: absolute;
  z-index: 2;
  background: rgba(154, 154, 154, 0.1);
  animation: _appear_16rp3_1 1s ease-in-out forwards; }
  ._animationIdle_16rp3_58._lineHorizontal_16rp3_6 ._glowIdle_16rp3_11 {
    animation-name: _idleHorizontalKeyframes_16rp3_1; }
  ._animationIdle_16rp3_58._lineHorizontalToRight_16rp3_65 ._glowIdle_16rp3_11 {
    transform-origin: calc(100% - 20%) 0;
    background: var(--line-glow-background-direction-to-right); }
  ._animationIdle_16rp3_58._lineHorizontalToLeft_16rp3_68 ._glowIdle_16rp3_11 {
    transform-origin: 20% 0;
    background: var(--line-glow-background-direction-to-left); }
  ._animationIdle_16rp3_58._lineVertical_16rp3_29 ._glowIdle_16rp3_11 {
    animation-name: _idleVerticalKeyframes_16rp3_1; }
  ._animationIdle_16rp3_58._lineVerticalToTop_16rp3_73 ._glowIdle_16rp3_11 {
    transform-origin: 0 20%;
    background: var(--line-glow-background-direction-to-top); }
  ._animationIdle_16rp3_58._lineVerticalToBottom_16rp3_76 ._glowIdle_16rp3_11 {
    transform-origin: 0 calc(100% - 20%);
    background: var(--line-glow-background-direction-to-bottom); }

._animationIdle_16rp3_58 ._glowIdle_16rp3_11 {
  animation-duration: var(--idle-duration);
  animation-delay: var(--idle-delay);
  animation-timing-function: ease-in-out;
  animation-fill-mode: both; }

@keyframes _idleHorizontalKeyframes_16rp3_1 {
  0% {
    transform: translateXvar(--idle-from-translate) scaleXvar(--idle-from-scale); }
  100% {
    transform: translateXvar(--idle-to-translate) scaleXvar(--idle-to-scale); } }

@keyframes _idleVerticalKeyframes_16rp3_1 {
  0% {
    transform: translateYvar(--idle-from-translate) scaleYvar(--idle-from-scale); }
  100% {
    transform: translateYvar(--idle-to-translate) scaleYvar(--idle-to-scale); } }

@keyframes _impulseFromCenterOneHorizontal_16rp3_1 {
  0% {
    transform: scaleX0; }
  30% {
    transform: scaleX1 translateX-5%;
    opacity: 1; }
  50% {
    transform: scaleX2 translateX-20%; }
  100% {
    transform: scaleX2 translateX-100%;
    opacity: 0; } }

@keyframes _impulseFromCenterTwoHorizontal_16rp3_1 {
  0% {
    transform: scaleX0; }
  30% {
    transform: scaleX1 translateX5%;
    opacity: 1; }
  50% {
    transform: scaleX2 translateX20%; }
  100% {
    transform: scaleX2 translateX100%;
    opacity: 0; } }

@keyframes _impulseFromCenterOneVertical_16rp3_1 {
  0% {
    transform: scaleY0; }
  30% {
    transform: scaleY1 translateY-5%;
    opacity: 1; }
  50% {
    transform: scaleY2 translateY-20%; }
  100% {
    transform: scaleY2 translateY-100%;
    opacity: 0; } }

@keyframes _impulseFromCenterTwoVertical_16rp3_1 {
  0% {
    transform: scaleY0; }
  30% {
    transform: scaleY1 translateY5%;
    opacity: 1; }
  50% {
    transform: scaleY2 translateY20%; }
  100% {
    transform: scaleY2 translateY100%;
    opacity: 0; } }

@keyframes _appear_16rp3_1 {
  0% {
    opacity: 0; }
  100% {
    opacity: 1; } }

.ANIMATION_IMPULSE_FROM_RIGHT ._glowIdleWrapper_16rp3_55,
.ANIMATION_IMPULSE_FROM_CENTER ._glowIdleWrapper_16rp3_55 {
  opacity: 0.2; }

.ANIMATION_IMPULSE_FROM_RIGHT ._glowImpulseFromRight_16rp3_13 {
  transition-duration: var(--impulse-from-right-duration);
  transition-timing-function: ease-in-out;
  transition-delay: calc(var(--from-center-index) * var(--impulse-from-right-delay-multiplier));
  transform: translateX(-200%) scaleX(2); }

.ANIMATION_IMPULSE_FROM_CENTER ._line_16rp3_1 ._glowImpulseFromCenterOne_16rp3_18, .ANIMATION_IMPULSE_FROM_CENTER ._line_16rp3_1 ._glowImpulseFromCenterTwo_16rp3_18 {
  animation-timing-function: linear; }

.ANIMATION_IMPULSE_FROM_CENTER ._lineHorizontal_16rp3_6 ._glowImpulseFromCenterOne_16rp3_18, .ANIMATION_IMPULSE_FROM_CENTER ._lineHorizontal_16rp3_6 ._glowImpulseFromCenterTwo_16rp3_18 {
  animation-duration: var(--impulse-from-center-duration-horizontal);
  animation-delay: var(--impulse-from-center-delay-horizontal); }

.ANIMATION_IMPULSE_FROM_CENTER ._lineHorizontal_16rp3_6 ._glowImpulseFromCenterOne_16rp3_18 {
  animation-name: _impulseFromCenterOneHorizontal_16rp3_1; }

.ANIMATION_IMPULSE_FROM_CENTER ._lineHorizontal_16rp3_6 ._glowImpulseFromCenterTwo_16rp3_18 {
  animation-name: _impulseFromCenterTwoHorizontal_16rp3_1; }

.ANIMATION_IMPULSE_FROM_CENTER ._lineVertical_16rp3_29 ._glowImpulseFromCenterOne_16rp3_18, .ANIMATION_IMPULSE_FROM_CENTER ._lineVertical_16rp3_29 ._glowImpulseFromCenterTwo_16rp3_18 {
  animation-duration: var(--impulse-from-center-duration-vertical);
  animation-delay: var(--impulse-from-center-delay-vertical); }

.ANIMATION_IMPULSE_FROM_CENTER ._lineVertical_16rp3_29 ._glowImpulseFromCenterOne_16rp3_18 {
  animation-name: _impulseFromCenterOneVertical_16rp3_1; }

.ANIMATION_IMPULSE_FROM_CENTER ._lineVertical_16rp3_29 ._glowImpulseFromCenterTwo_16rp3_18 {
  animation-name: _impulseFromCenterTwoVertical_16rp3_1; }
